import { useState, useEffect } from "react";
import { Mail, Phone, Clock, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export default function AdminEnquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Run once on mount; auth check is intentionally not re-run.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    api.get("/admin/contacts").then((r) => setItems(r.data)).catch(() => toast.error("Failed to load enquiries")).finally(() => setLoading(false));
  }, []);

  const remove = async (c) => {
    if (!window.confirm(`Delete enquiry from ${c.name}? This cannot be undone.`)) return;
    try {
      await api.delete(`/admin/contacts/${c.id}`);
      setItems((prev) => prev.filter((x) => x.id !== c.id));
      toast.success("Enquiry deleted");
    } catch { toast.error("Delete failed"); }
  };

  return (
    <div>
      <div className="mb-8">
        <div className="overline mb-2">Administration</div>
        <h1 className="font-dash text-3xl">Enquiries</h1>
        <p className="text-zinc-500 mt-2 text-sm">Messages submitted through the public contact form.</p>
      </div>
      {loading ? (
        <div className="text-zinc-500 text-sm py-10 text-center">Loading…</div>
      ) : items.length === 0 ? (
        <div className="rounded-xl border border-dashed border-white/12 py-16 text-center text-zinc-500" data-testid="enquiries-empty">
          <Mail size={28} strokeWidth={1} className="mx-auto mb-3 opacity-60" /> No enquiries yet.
        </div>
      ) : (
        <div className="space-y-4" data-testid="enquiries-list">
          {items.map((c) => (
            <div key={c.id} className="rounded-xl border border-white/10 bg-[#0b0b0b] p-6" data-testid={`enquiry-${c.id}`}>
              <div className="flex items-start justify-between flex-wrap gap-3">
                <div>
                  <div className="text-white">{c.name}{c.subject ? ` — ${c.subject}` : ""}</div>
                  <div className="flex flex-wrap items-center gap-x-5 gap-y-1 mt-1 text-xs text-zinc-500">
                    <a href={`mailto:${c.email}`} className="flex items-center gap-1.5 hover:text-white"><Mail size={12} /> {c.email}</a>
                    {c.phone && <span className="flex items-center gap-1.5"><Phone size={12} /> {c.phone}</span>}
                    <span className="flex items-center gap-1.5"><Clock size={12} /> {fmt(c.created_at)}</span>
                  </div>
                </div>
                <button onClick={() => remove(c)} className="p-2 text-zinc-500 hover:text-red-400 transition-colors" title="Delete enquiry" data-testid={`delete-enquiry-${c.id}`}>
                  <Trash2 size={16} />
                </button>
              </div>
              <p className="text-zinc-300 text-sm mt-4 leading-relaxed whitespace-pre-line">{c.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
